module.exports = __webpack_public_path__ + "media/application/images/icons/glossary-icon-f00b914f2be3131b84439e2214a2e54c.svg";